import { mapState } from 'vuex'
import { FeatureFlags } from '@/utils/feature-flags.enum'

export default {
  computed: {
    ...mapState('dashboard', ['hasNewSocialSiteFlag']),
    activeFeatures() {
      return { [FeatureFlags.NewSocialSite]: this.hasNewSocialSiteFlag }
    },
  },
  methods: {
    hasPermisionAndFeature(page) {
      const hasPermission = this.$hasPermission(page.permissions)
      const showFeature = Object.entries(page.features ?? {}).every(
        ([feature, show]) => {
          if (this.activeFeatures[feature] == null) return true
          return this.activeFeatures[feature] ? show : !show
        }
      )
      return hasPermission && showFeature
    },
  },
}
